export default "__VITE_ASSET__BpW4I2rk__"